import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { applyScrollOffsetsToHtmlCoordinate, Label, Pie as DataVizPie, Svg, svgCoordinateToHtmlCoordinate } from '@opengov/data-viz';
import stubFalse from 'lodash/stubFalse';
import throttle from 'lodash/throttle';
import uniq from 'lodash/uniq';
import * as React from 'react';
import { MessageOverlay } from '../MessageOverlay';
import * as defaultStyles from './Pie.scss';
export var Pie = /*#__PURE__*/function (_React$Component) {
  _inherits(Pie, _React$Component);

  var _super = _createSuper(Pie);

  function Pie(props) {
    var _this;

    _classCallCheck(this, Pie);

    _this = _super.call(this, props);

    _this.measureChartContainer = function (element) {
      _this.chartContainer = element;
    };

    _this.handleChartResize = function () {
      if (_this.props.onChartResize && _this.chartContainer) {
        _this.props.onChartResize(_this.chartContainer.getBoundingClientRect());
      }
    };

    _this.elementStrokeColorForCategory = function (category) {
      if (!_this.props.selectedCategory) {
        return 'white';
      }

      return category === _this.props.selectedCategory ? 'white' : 'none';
    };

    _this.onElementEnter = function (category, data, segment, target, labelArc, sliceArc) {
      var centroid = sliceArc.centroid(null);
      var domPoint = svgCoordinateToHtmlCoordinate(target, {
        x: centroid[0],
        y: centroid[1]
      });
      var domCoordinate = applyScrollOffsetsToHtmlCoordinate(domPoint);

      _this.props.onElementEnter(category, data, domCoordinate, target);
    };

    _this.handleChartResize = throttle(_this.handleChartResize, 128);
    return _this;
  }

  _createClass(Pie, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleChartResize);
      this.handleChartResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleChartResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          axisName = _this$props.axisName,
          chartCalculations = _this$props.chartCalculations,
          dataTest = _this$props.dataTest,
          messageOverlayProps = _this$props.messageOverlayProps,
          _this$props$showOverl = _this$props.showOverlay,
          showOverlay = _this$props$showOverl === void 0 ? false : _this$props$showOverl,
          _this$props$showOutli = _this$props.showOutline,
          showOutline = _this$props$showOutli === void 0 ? false : _this$props$showOutli,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? defaultStyles : _this$props$style,
          _this$props$xLabelFor = _this$props.xLabelFormatter,
          xLabelFormatter = _this$props$xLabelFor === void 0 ? function (value) {
        return "".concat(value);
      } : _this$props$xLabelFor,
          elementColorFor = _this$props.elementColorFor,
          onElementClick = _this$props.onElementClick,
          onElementLeave = _this$props.onElementLeave;
      var coordinateSystem = chartCalculations.coordinateSystem,
          dimensions = chartCalculations.dimensions,
          margin = chartCalculations.margin,
          pieData = chartCalculations.pieData,
          categories = chartCalculations.categories;
      var radius = Math.min.apply(Math, [dimensions.height, dimensions.width]) / 2;
      return React.createElement("div", {
        ref: this.measureChartContainer,
        "data-test": dataTest,
        className: style.container
      }, showOverlay && this.chartContainer && React.createElement(MessageOverlay, Object.assign({}, messageOverlayProps, {
        leftMargin: margin.left,
        width: this.chartContainer.getBoundingClientRect().width - margin.left
      })), React.createElement(Svg, {
        coordinateSystem: coordinateSystem
      }, React.createElement("g", {
        transform: "translate(".concat(margin.left, ", ").concat(margin.top, ")")
      }, React.createElement(DataVizPie, {
        categories: categories,
        dimensions: dimensions,
        radius: radius,
        series: pieData,
        showOutline: showOutline,
        showLabelFor: stubFalse,
        elementColorFor: elementColorFor,
        elementStrokeColorFor: this.elementStrokeColorForCategory,
        onElementClick: onElementClick,
        onElementEnter: this.onElementEnter,
        onElementLeave: onElementLeave
      }), React.createElement(PieAxisLabel, {
        axisName: axisName,
        axisLabel: formatPieAxisLabel(chartCalculations.data, xLabelFormatter),
        dimensions: dimensions,
        style: {
          axisLabel: style.axisLabel,
          axisName: style.axisName
        }
      }))));
    }
  }]);

  return Pie;
}(React.Component);
export var formatPieAxisLabel = function formatPieAxisLabel(data, formatter) {
  if (!data.length) {
    return '';
  }

  var first = data[0].name;
  var last = data[data.length - 1].name;
  var firstFormatted = formatter(first);
  var lastFormatted = formatter(last);
  return uniq([firstFormatted, lastFormatted]).join(' - ');
};

var PieAxisLabel = function PieAxisLabel(_ref) {
  var axisName = _ref.axisName,
      axisLabel = _ref.axisLabel,
      style = _ref.style,
      dimensions = _ref.dimensions;
  var x = dimensions.width / 2;
  var y = dimensions.height;
  return React.createElement(React.Fragment, null, React.createElement(Label, {
    text: axisName,
    x: x,
    y: y,
    textAnchor: "middle",
    dataTest: "axisName",
    style: {
      text: style.axisName
    }
  }), React.createElement(Label, {
    text: axisLabel,
    x: x,
    y: y,
    dy: "1.5em",
    textAnchor: "middle",
    dataTest: "axisLabel",
    style: {
      text: style.axisLabel
    }
  }));
};